export interface ResetPasswordDto {
  userId: string,
  token: string,
  password: string,
  confirmPassword: string,
}

export const resetPasswordInit: ResetPasswordDto = { userId: '', token: '', password: '', confirmPassword: '' };